
import { Component, Vue, Watch } from 'vue-property-decorator';

import CPLoader from '@/components/globals/CPLoader.vue';
import CPFetchingOverlay from '@/components/globals/CPFetchingOverlay.vue';
import CPAlertsEdit from '@/components/globals/CPAlertsEdit.vue';
import { Product } from '@/definitions/definitions';

@Component({
  components: {
    CPFetchingOverlay,
    CPLoader,
    CPAlertsEdit,
  },
})
export default class CPAlerts extends Vue {

  public opened: number[] = [];

  public get alerts(): any {
    return this.$store.state.alerts.alertsList;
  }
  public get alertEdit() {
    return this.$store.state.alerts.editAlert;
  }
  public get fetching() {
    return this.$store.state.alerts.fetching;
  }

  public get activeAccountId() {
    return this.$store.state.account.details.activeAccountId;
  }

  @Watch('activeAccountId')
  public updateAlert() {
    this.$store.dispatch('getAlerts');
  }

  public editAlert(alert: any) {
    this.$store.commit('setEditAlert', alert);
  }

  public close() {
    this.editAlert(null);
    this.$store.commit('toggleAlerts', false);

  }

  public async toggle(id: number) {
    const index = this.opened.indexOf(id);
    this.opened = [];
    if (index > -1) {
      this.opened.splice(index, 1);
    } else {
      this.opened.push(id);
    }
  }


  public showFactSheet(product: Product) {
    this.$store.dispatch('getFundDetails', product);
  }

  public mounted() {
    this.$store.dispatch('getAlerts');
  }
}
